"use client";

// Toko aktif SISI KLIEN (multi-tenant) — cermin `storeContextServer.ts` untuk
// browser. Di-set SEKALI oleh <Providers> (root layout server sudah meresolusi
// Host → store lewat RPC `resolve_store_public`, lalu mengoper `storeId` sebagai
// prop) dan dibaca data layer klien untuk MEN-SCOPE query per-toko.
//
// KENAPA PERLU: kebijakan RLS store-scoped (mig 3040) memakai cabang ESCAPE
// `current_store_id() is null or store_id = current_store_id()` (keputusan A2)
// supaya storefront publik tetap hidup — artinya sesi ANON (belum login) lolos
// escape dan melihat baris SEMUA toko. Query klien yang bisa dicapai tanpa
// login (branding halaman login, popup storefront, strip program poin) karena
// itu WAJIB menambahkan filter `store_id` sendiri; tanpa itu, toko kedua
// menampilkan branding/marketing toko pertama (bug live zzhomey → Galea).
// Sesi ber-JWT store claim tetap di-scope RLS — filter ini redundan-aman.
//
// ⛔ NULL = "TIDAK ADA TOKO", BUKAN "TOKO MANA SAJA" — pemanggil WAJIB
// FAIL-CLOSED (kembalikan kosong / nilai bawaan), JANGAN menjalankan query
// tanpa filter, dan jangan pernah menebak toko default di sini.
//
// Aturan ini ditulis dengan darah: versi pertama modul ini menyarankan
// "null → jangan memfilter (fail-open)" dan KEEMPAT pemanggilnya menurut. Di
// apex platform `kelolify.com` tak ada toko yang ter-resolusi (RPC
// `resolve_store_public` memang memulangkan NULL untuk host platform), jadi
// justru di situ filternya dilewati dan query memulangkan baris SELURUH TENANT
// — popup milik zzhomey tampil di halaman jualan platform. Subdomain tenant
// lain tampak "aman" hanya karena di sana storeId terisi, sehingga kebocoran
// ini tak terlihat dari pengujian antar-tenant.
//
// Fail-open di sini selalu bertukar "sedikit data hilang" dengan "data tenant
// lain tersaji". Pilih yang pertama; lihat `fetchActivePromoCampaigns`,
// `fetchActivePopups`, `fetchSiteSettings`, `fetchTutorialSections`,
// `fetchActivePrograms` — kelimanya kini sekata.

let clientStoreId: string | null = null;

/** Dipanggil <Providers> saat render (guard browser-only di pemanggil). */
export function setClientStoreId(id: string | null): void {
  clientStoreId = id;
}

/** Toko hasil resolusi Host; null bila belum di-set / resolusi gagal. */
export function getClientStoreId(): string | null {
  return clientStoreId;
}
